module.exports = __webpack_public_path__ + "static/media/bg_lightspot.d89251b1.png";